/*
 * @Author: hzm
 * @Date: 2022-11-25 16:04:37
 * @Description:
 */

export const Mrohistory = 'Mrohistory';
